import { ConnectionService, NewVersionPopupComponent, VersionService } from '@agroone-front/shared'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { DestroyRef, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { catchError, of, switchMap } from 'rxjs'
import { syncOfflineActions } from './scene/crop-management/crop/store/actions/offline.actions'
import { OfflineState } from './scene/crop-management/crop/store/reducers'
import { selectOfflineActions } from './scene/crop-management/crop/store/selectors/offline.selectors'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

declare const dT_: { initAngularNg?: (http: HttpClient, headers: typeof HttpHeaders) => void } | undefined
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, NewVersionPopupComponent],
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef)

  private matIconRegistry = inject(MatIconRegistry)
  private sanitizer = inject(DomSanitizer)
  private http = inject(HttpClient)
  private connectionService = inject(ConnectionService)
  private offlineStore = inject(Store<OfflineState>)
  protected versionService = inject(VersionService)

  ngOnInit(): void {
    this.matIconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/icon-set.svg'))
    this.matIconRegistry.addSvgIcon('farm', this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/farm.svg'))

    this.versionService.checkForUpdates()

    if (typeof dT_ !== 'undefined' && dT_.initAngularNg) {
      dT_.initAngularNg(this.http, HttpHeaders)
    }
    this.onSyncBackground()
  }

  private onSyncBackground(): void {
    this.connectionService.connection$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(() => of([])),
        switchMap((isConnected) => {
          if (isConnected) {
            return this.offlineStore.select(selectOfflineActions)
          }
          return of([])
        }),
      )
      .subscribe((actions) => {
        if (actions?.length) {
          this.offlineStore.dispatch(syncOfflineActions({ actions }))
        }
      })
  }
}
